<section class="left">
  @if (logoNavigates) {
    <a class="logo" [routerLink]="['/maps']" routerLinkActive="active" (click)="navigate.next($event)">
      <img [src]="logoUrl" alt="Logo" />
    </a>
  } @else {
    <div class="logo" (click)="navigate.next($event)" role="button" tabindex="0">
      <img [src]="logoUrl" alt="Logo" />
    </div>
  }
  <ng-content select="[la-contextual-header-title]"></ng-content>
</section>

<section class="middle">
  <ng-content select="[la-contextual-header-middle]"></ng-content>
</section>

<section class="right">
  <ng-content select="[la-contextual-header-actions]"></ng-content>

  @if (user) {
    <la-icon-button icon="person" class="person" [matMenuTriggerFor]="profileMenu"></la-icon-button>
  }

  <mat-menu #profileMenu="matMenu" [overlapTrigger]="false" xPosition="before" yPosition="below">
    <ng-content select="[la-contextual-menu-content]"></ng-content>
    <button mat-menu-item [routerLink]="['/referrals']" (click)="navigate.emit()">
      <mat-icon class="material-icons-outlined">connect_without_contact</mat-icon>
      <span>Referrals</span>
    </button>
    <button mat-menu-item [routerLink]="['/account']" (click)="navigate.emit()">
      <mat-icon class="material-icons-outlined">person</mat-icon>
      <span>Account</span>
    </button>
    <button mat-menu-item [routerLink]="['/maps']" (click)="navigate.emit()">
      <mat-icon class="material-icons-outlined">dashboard</mat-icon>
      <span>Maps</span>
    </button>
    <button mat-menu-item (click)="openPrints()">
      <mat-icon class="material-icons-outlined">printer</mat-icon>
      <span>Prints</span>
    </button>
    <button mat-menu-item (click)="openDataPurchases()">
      <mat-icon class="material-icons-outlined">shop</mat-icon>
      <span>Data purchases</span>
    </button>
    <button mat-menu-item (click)="openTitlePurchases()">
      <mat-icon class="material-icons-outlined">description</mat-icon>
      <span>Title purchases</span>
    </button>
    <button mat-menu-item (click)="openPortfolio()">
      <mat-icon class="material-icons-outlined">analytics</mat-icon>
      <span>Portfolio</span>
    </button>
    @if (!!isNatureReportingEnabled) {
      <button mat-menu-item (click)="openNatureReporting()">
        <mat-icon class="material-icons-outlined">eco</mat-icon>
        <span>Nature Reporting</span>
      </button>
    }
    <button mat-menu-item (click)="openHelp()">
      <mat-icon class="material-icons-outlined">help_outline</mat-icon>
      <span>Help</span>
    </button>
    @if (isAdmin) {
      <button mat-menu-item [routerLink]="['/admin']">
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        <span>Admin</span>
      </button>
    }
    <button mat-menu-item [routerLink]="['/logged-out']" (click)="storeLastLocation()">
      <mat-icon class="material-icons-outlined">exit_to_app</mat-icon>
      <span>Sign out</span>
    </button>
  </mat-menu>

  <ng-content select="[la-contextual-after-person-icon]"></ng-content>
</section>
